<template>
  <van-dialog v-model="visible" :showConfirmButton="false" :style="{ backgroundColor: '#ffffff', width: isMobile ? '95%' : '700px', marginTop: isMobile ? '0' : '22px' }">
    <div class="dialog-content">
      <div class="dialog-title">
        <div class="dialog-title-main">
          <div>
            <van-icon name="question-o" />
            {{ info.topic }}
          </div>
          <van-icon name="cross" size="14" color="white" style="font-weight: 600" @click="clear()" />
        </div>
        <!-- <div class="dialog-title-sub">
					<div>{{ info.topic }}</div>
				</div> -->
      </div>
    </div>

    <div class="dialog-content-input">
      <div class="content-title" v-for="(item, index) in info.contentList" :key="index">
        <div style="font-size: 16px; font-weight: 550; color: #1891f6">{{ item.subTitle }}</div>
        <div :style="{ color: item.level == 'H' ? '#FC8239' : 'black' }">{{ item.content }}</div>

        <!-- <div v-if="index == 0 && isShowManualUrl()" style="margin-top: 8px; color: #1891f6">
          <a href="https://d2m1ju11hc3nlf.cloudfront.net/manual/Digital_e-CAT_Workflow_Document_v1.2.pdf" target="_blank" rel="noopener noreferrer">
            {{ $t("explan.common.toLearnOpen") + ": Digital_e-CAT_Workflow_Document_v1.2.pdf" }}
          </a>
        </div> -->
      </div>

      <!-- <div class="tip-words">
        <van-checkbox v-model="checked" icon-size="24px" shape="square" style="text-align: center">
          {{ $t("explan.common.dontDisplayAgain") }}
        </van-checkbox>
        <div v-if="checked" style="color: #eb5623">{{ $t("explan.common.promptDisabledReopen") }}</div>
      </div> -->

      <div class="button-bar">
        <van-button class="submit-btn linear-blue-color" @click="clickBtn('goBack')">
          <div style="font-size: 14px">
            {{ $t("dashboard.common.iKnowThis") }}
          </div>
        </van-button>

        <!-- <van-button class="submit-btn linear-blue-color" @click="clickBtn('goTo')">
          <div style="font-size: 14px">
            {{ $t("explan.common.continue") }}
          </div>
        </van-button> -->
      </div>
    </div>
  </van-dialog>
</template>

<script>
import langStruct from "@/locale/explan/en.js"

export default {
  name: "SelfExplanation",
  props: {
    code: { type: [String, Number], default: "" },
    goToFun: { type: Function, default: null },
    goBackFun: { type: Function, default: null }
  },
  data() {
    return {
      visible: false,
      isMobile: false,
      checked: false,

      info: {
        topic: "",
        contentList: [
          /*{content: "", level: "H", subTitle: "explan.common.what"}*/
        ]
      }
    }
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler(newVisible, oldVisible) {
        if (oldVisible == false && newVisible == true) {
          let keyCode = `E${this.code}`
          if (keyCode in langStruct) {
            // 存在这个code的解释
            this.info.topic = this.$t(`explan.${keyCode}.topic`)

            let dataContent = langStruct[keyCode]
            for (let i = 1; i <= 5; i++) {
              let contentKey = `content_${i}`

              const key = Object.keys(dataContent).find(k => k.startsWith(contentKey))

              if (key) {
                let arr = key.split("_")
                if (arr.length === 3) {
                  this.info.contentList.push({
                    content: this.$t(`explan.${keyCode}.${key}`),
                    level: arr[2],
                    subTitle: i == 1 ? this.$t(`explan.common.what`) : i == 2 ? this.$t(`explan.common.why`) : ""
                  })
                }
              } else {
                return // 顺序查找结束
              }
            }
          } else {
            this.info.topic = this.$t("explan.common.cantFindTheCode") + this.code
            this.info.contentList = [{ content: this.$t("explan.common.noContent"), level: "M" }]
          }
        }
      }
    }
  },
  mounted() {
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  },
  methods: {
    clickBtn(action) {
      this.clear()

      if (action === "goTo" && this.goToFun) {
        this.goToFun()
      } else if (action === "goBack" && this.goBackFun) {
        this.goBackFun()
      }
    },
    show() {
      this.visible = true
    },
    clear() {
      this.visible = false
      this.info = {
        topic: "",
        contentList: []
      }
    },
    isShowManualUrl() {
      return [10901, 10902, 10613, 10623].includes(this.code)
    }
  }
}
</script>

<style scoped>
.dialog-content {
  max-height: 60vh;
  display: flex;
  flex-direction: column;
}

.dialog-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 20px;
  font-weight: 550;
  color: #ffffff;
  padding: 16px 20px;
  background-color: #1891f6;
}

.dialog-title-main {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.dialog-title-sub {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 400;
}

.dialog-content-input {
  margin-top: 16px;
  padding-left: 22px;
  padding-right: 22px;
}

.submit-btn {
  width: 45%;
  max-width: 300px;
  height: 44px;
  border-radius: 8px;
  color: #ffffff;
  /* background: linear-gradient(to right, #3b82f6, #4f47e5); */
  background-color: #1891f6;
}

.linear-blue-color {
  /* background: linear-gradient(to right, #3b82f6, #4f47e5); */
  background-color: #1891f6;
}

.linear-green-color {
  background-color: #04b357;
  /* background: linear-gradient(to right, #65cf99, #04b357); */
}

.content-title {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 12px;
}

.tip-words {
  margin-top: 16px;
  margin-bottom: 16px;
  color: #8a8a8a;
  font-size: 14px;
}

.button-bar {
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/SelfExplanation/SelfExplanation.vue